var render = function (_h,_vm) {var _c=_vm._c;return _c('b-nav-item',{staticClass:"navbar-general",attrs:{"active":_vm.props.active,"to":_vm.props.to}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }